import styled from 'styled-components';

const AvgTimeContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
`;

const LinkButton = styled.a`
  color: var(--color-neutral-800);
  cursor: pointer;
  text-decoration: underline;
`;

const BarArea = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: 12px;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
`;

const CardFooter = styled.div``;

const Rate = styled.div`
  font-weight: bold;
  text-align: right;
  width: 78px;
  word-break: keep-all;
`;

const StatusWrapper = styled.div`
  display: flex;
  flex-direction: column;

  .item-body {
    gap: 24px;
    padding: 0 !important;
  }
`;

const StatusInfoWrapper = styled.div`
  display: flex;
  gap: 16px;
`;

const ReactivateText = styled.div`
  color: var(--color-fg-weaker);
  margin-top: 16px;
  text-align: center;
`;

const StatusBadge = styled.div`
  align-items: center;
  border: 1px solid var(--color-accent-secondary-weaker);
  border-radius: var(--radius-m);
  display: flex;
  gap: 4px;
  padding: 8px;
`;

const StatusSummaryHeader = styled.div`
  margin-bottom: 16px;
`;

export {
  AvgTimeContainer,
  BarArea,
  ButtonWrapper,
  CardFooter,
  LinkButton,
  Rate,
  ReactivateText,
  StatusBadge,
  StatusInfoWrapper,
  StatusSummaryHeader,
  StatusWrapper
};
